import { colors, fonts } from '@grupoboticario/flora-tokens/casaMagalhaesNoite/web/ds'

export const casaMagalhaesNoite = {
  colors,
  fonts,
}
